import { render, staticRenderFns } from "./UserPassword.vue?vue&type=template&id=ea7be354&"
import script from "./UserPassword.vue?vue&type=script&lang=js&"
export * from "./UserPassword.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports